import { formatMoney, formatNumber } from "app/common/LocalFunction";
import React from "react";

const RowTotalProduct = ({ data }) => {
  return (
    <table className="table-total-amount payment-summary-box">
      <tr>
        <td colSpan={4}></td>
        <td colSpan={4}></td>
        <td colSpan={4}>
          <div className="flex justify-between">
            <p>Thành tiền:</p> <b>{formatMoney(+data?.totalAmount)}</b>
          </div>
        </td>
      </tr>

      <tr>
        <td colSpan={4}></td>
        <td colSpan={4}></td>
        <td colSpan={4}>
          <div className="flex justify-between">
            Số lượng: <b>{formatNumber(data?.soldQuantity)}</b>
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan={4}></td>
        <td colSpan={4}></td>
        <td colSpan={4}>
          <div className="flex justify-between">
            Miễn giảm: <b>{formatMoney(+data?.discount)}</b>
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan={4}></td>
        <td colSpan={4}></td>
        <td colSpan={4}>
          <div className="flex justify-between">
            <b className="flex justify-between" style={{ width: "100%" }}>
              Số tiền (sau giảm):{" "}
              <b>{formatMoney(+data?.totalAmount - (+data?.discount || 0))}</b>
            </b>
          </div>
        </td>
      </tr>
      <tr>
        <td colSpan={4}></td>
        <td colSpan={4}></td>
        <td colSpan={4}>
          <div className="flex justify-between">
            Vat: <b>{formatMoney(+data?.taxTotal)}</b>
          </div>
        </td>
      </tr>

      <tr>
        <td colSpan={4}></td>
        <td colSpan={4}></td>
        <td colSpan={4}>
          <div
            style={{
              background: "#333",
              width: "100%",
              height: "1px",
              margin: "4px 0",
            }}
          ></div>
        </td>
      </tr>
      <tr>
        <td colSpan={4}></td>
        <td colSpan={4}></td>
        <td colSpan={4}>
          <div className="flex justify-between">
            <b className="flex justify-between" style={{ width: "100%" }}>
              Tổng thanh toán:{" "}
              <b>
                {data?.priceWithTax
                  ? formatMoney(+data?.totalAmount - (+data?.discount || 0))
                  : formatMoney(
                      +data?.totalAmount -
                        (+data?.discount || 0) +
                        (+data?.taxTotal || 0)
                    )}
              </b>
            </b>
          </div>
        </td>
      </tr>
    </table>
  );
};

export default RowTotalProduct;
